"use strict";
exports.__esModule = true;
exports.FieldGroupDocument = void 0;
var FieldGroupDocument = /** @class */ (function () {
    function FieldGroupDocument(org_id, name, label, field_entity, can_delete) {
        this.org_id = org_id;
        this.name = name;
        this.label = label;
        this.field_entity = field_entity;
        this.can_delete = can_delete;
    }
    FieldGroupDocument.fromJSON = function (json) {
        var group = new FieldGroupDocument('', '', '', null, true);
        if (json) {
            group.org_id = json.org_id ? json.org_id : '';
            group.name = json.name ? json.name : '';
            group.label = json.label ? json.label : '';
            group.field_entity = json.field_entity ? json.field_entity : null;
            group.can_delete = json.can_delete !== undefined ? json.can_delete : true;
        }
        return group;
    };
    return FieldGroupDocument;
}());
exports.FieldGroupDocument = FieldGroupDocument;
